import { reportsTopProductsCategoryDistributionRetrieveOptions } from '@crm/api'
import { getColor } from '@crm/components/Charts/utils'
import { SkeletonWrapper } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, Dropdown } from 'antd'
import { More } from 'iconsax-react'

import { ReportsPieChart } from './ReportsPieChart'
import { useReportExport } from '../hooks'

export const CategoryDistributionChart = () => {
  const { t } = useLocales()
  const { params } = useQueryUpdate()

  const { onExport, dropdownItems } = useReportExport(
    'category-distribution',
    params
  )

  const { data, isLoading } = useQuery({
    ...reportsTopProductsCategoryDistributionRetrieveOptions({
      query: { date_from: params.date_from, date_to: params.date_to, ...params }
    }),
    enabled: !!params.date_from && !!params.date_to
  })

  const chartData =
    data?.categories?.map((item, index) => ({
      name: item.category_name ?? '-',
      opportunity_count: item.opportunity_count,
      total_value: item.total_value,
      currency: data?.currency?.symbol,
      total: item.opportunity_count,
      color: getColor(index)
    })) || []

  return (
    <Card
      title={t('reports.top_categories', { count: 10 })}
      loading={isLoading}
      extra={
        <Dropdown
          menu={{ items: dropdownItems, onClick: onExport }}
          trigger={['click']}
        >
          <Button icon={<More size={18} />} />
        </Dropdown>
      }
    >
      <SkeletonWrapper loading={isLoading} paragraph={{ rows: 10 }}>
        <ReportsPieChart
          data={chartData}
          chartText={t('nomenclature.categories')}
          textColumn={t('nomenclature.category')}
          chartHeight={300}
        />
      </SkeletonWrapper>
    </Card>
  )
}
